import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../../../auth/services';

@Injectable({
  providedIn: 'root',
})
export class ErrorService implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any) {
    const router = this.injector.get(Router);

    if (error instanceof HttpErrorResponse) {
      if (error.status === 400) {
      } else if (error.status === 401) {
        const authService = this.injector.get(AuthService);

        if (authService.isAuthenticated) router.navigate(['error/404']);
        else router.navigate(['login']);
      }
    }
    throw new Error(error);
    // router.navigate(['error/404']);
  }
}
